// Site-wide SEO constants + JSON-LD Schema.org builders.
export const SITE = {
  url: "https://adn-marketplace.com",
  name: "ADN Distressed Property Marketplace™",
  shortName: "ADN Marketplace",
  description:
    "ADN connects homeowners with verified investors, cash buyers, Realtors, lenders, attorneys, and contractors so they can compare real options before selling. Free for sellers.",
  logo: "https://adn-marketplace.com/icon-512.png",
  phone: "+1-555-555-0100",
  email: "contact@adnmarketplace.com",
  fax: "+1-555-555-0101",
};

export const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.name,
  alternateName: "ADN Marketplace",
  url: SITE.url,
  logo: SITE.logo,
  description: SITE.description,
  email: SITE.email,
  telephone: SITE.phone,
  faxNumber: SITE.fax,
  sameAs: [
    "https://facebook.com/",
    "https://instagram.com/",
    "https://linkedin.com/",
    "https://x.com/",
    "https://youtube.com/",
  ],
};

export const WEBSITE_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  url: SITE.url,
  description: SITE.description,
  publisher: { "@type": "Organization", name: SITE.name, url: SITE.url },
};

export const buildBreadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});

export const buildFAQ = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((q) => ({
    "@type": "Question",
    name: q.q,
    acceptedAnswer: { "@type": "Answer", text: q.a },
  })),
});

export const buildHowTo = (name, description, steps) => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  name,
  description,
  step: steps.map((s, i) => ({
    "@type": "HowToStep",
    position: i + 1,
    name: s.name,
    text: s.text,
  })),
});

export const buildService = (name, description, provider, offers) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  provider: { "@type": "Organization", name: provider || SITE.name, url: SITE.url },
  areaServed: { "@type": "Country", name: "United States" },
  ...(offers ? { offers } : {}),
});

export const HOME_FAQS = [
  {
    q: "What is ADN Distressed Property Marketplace?",
    a: "ADN is a neutral marketplace that connects distressed property owners with verified buyers, investors, Realtors, lenders, attorneys, and contractors so sellers can compare multiple options — cash offers, listing proposals, foreclosure help, creative financing — before choosing how to sell.",
  },
  {
    q: "Does it cost a seller to use ADN?",
    a: "No. Sellers submit their property for free and never pay ADN. Providers (investors and professionals) pay a monthly subscription to access the marketplace.",
  },
  {
    q: "How fast can a homeowner get an offer?",
    a: "Most sellers receive multiple offers within 24 to 72 hours of submission. Cash offers can close in 7 to 21 days when speed is needed.",
  },
  {
    q: "What property situations does ADN handle?",
    a: "Foreclosure, behind on mortgage, probate, inherited property, divorce, tax delinquent, vacant property, code violations, properties needing repairs, absentee owners, and any homeowner wanting to compare a cash sale versus a traditional listing.",
  },
  {
    q: "Is ADN a real-estate brokerage?",
    a: "No. ADN is a marketplace and technology platform. It does not provide legal, tax, financial, or real-estate advice and does not represent buyers or sellers as a brokerage.",
  },
  {
    q: "How does ADN's AI help?",
    a: "After a seller submits their property, AI generates a neutral situation summary, scores distress level on a 0 to 100 scale, estimates equity, recommends realistic solution paths, and produces a side-by-side comparison of offers received.",
  },
];
